module.exports = __webpack_public_path__ + "img/nlic_gallery5.26488cbf.jpg";